"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authenticateUser = void 0;
/**
 * Authenticate User
 *
 * This function authenticate a user in the session
 */
var authenticateUser = function () {
    var TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJwZXJyeS5hbmRlcnNvbiIsImNvZ25pdG86Z3JvdXBzIjpbInN0dWRlbnQiXSwiYXV0aG9yaXRpZXMiOltdfQ.JjWpIcQozDz1CB09cgZMbk0E5zMATzngS1nZ4etON7Y';
    var LICENSING_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJsaWNlbnNlcyI6W3sicHJvZHVjdCI6eyJpZCI6ImFmZmlybSJ9LCJjdXJyaWN1bHVtIjp7ImlkIjoiRXVyZWthIE1hdGgifX1dfQ.P5NL4qpe_2zCg5pjE9XkUkDL2M0kBml7YzZPiWPcqvM';
    Object.defineProperty(window.document, 'cookie', {
        writable: true,
        value: "user=".concat(TOKEN, "; licensing=").concat(LICENSING_TOKEN),
    });
};
exports.authenticateUser = authenticateUser;
